import React from "react";

const SummaryCard = ({ icon, title, value, cardStyle, iconStyle, titleStyle, valueStyle, item, isPercentage = false }) => {

    const formatValue = (val, isPercentage) => {
        if (isPercentage) {
            return val !== null && val !== undefined && !isNaN(val) ? val.toFixed(2) : "0.00";
        }

        if (typeof val === 'number') {
            if (val >= 10000000) { // Crores
                return (val / 10000000).toFixed(2) + " Cr";
            } else if (val >= 100000) { // Lakhs
                return (val / 100000).toFixed(2) + " L";
            } else {
                return val.toString();
            }
        } else {
            return val; 
        }
    };

    const formattedValue = formatValue(value, isPercentage);

    return (
        <div className="bg-white/90 backdrop-blur-sm p-4 sm:p-5 rounded-lg shadow-sm hover:shadow-xl hover:scale-[1.02] transition-all duration-300 border border-gray-100/50 min-h-32 group" style={cardStyle}>
            <div className="flex items-center gap-3 sm:gap-4 h-full">
                <div className="flex justify-center items-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-flamingo-400 to-flamingo-500 text-white shadow-lg group-hover:shadow-xl transition-all duration-300 shrink-0" style={iconStyle}>
                    {React.cloneElement(icon, { size: 22 })}
                </div>
                <div className="flex-1 min-w-0">
                    <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2 leading-4 truncate" title={title} style={titleStyle}>{title}</h3>
                    <div className="flex items-baseline gap-2 min-w-0">
                        <p className="text-2xl md:text-3xl leading-none font-bold text-slate-900 truncate" title={`${formattedValue}${isPercentage ? "%" : ""}`} style={valueStyle}>
                            {formattedValue}
                            {isPercentage && "%"}
                        </p>
                        {item && (
                            <span className="text-sm font-medium text-slate-400 shrink-0">{item}</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummaryCard;